/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgArrowTriangleDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
    <path d='M17.852 9.909c.293-.283.138-.651-.345-.822a1.607 1.607 0 0 0-.53-.087H7.023C6.459 9 6 9.268 6 9.598c0 .11.051.217.148.311l4.977 4.802c.292.283.922.374 1.405.202.141-.05.26-.119.346-.202l4.976-4.802z' />
  </svg>
)
export default SvgArrowTriangleDown
